<ng-container *ngIf="parentHeroComponent">
  <ng-container *ngTemplateOutlet="classificationsHeroSection"></ng-container>
</ng-container>
<ng-container *ngIf="parentTechnicalInformationComponent">
  <ng-container *ngTemplateOutlet="classificationsAndCategoriesTechnicalInformationSection"></ng-container>
</ng-container>

<!--  classifications hero section -->
<ng-template #classificationsHeroSection>
  <div *ngIf="hasClassification"
       class="d-flex flex-column flex-sm-row flex-wrap classification-section">
    <div *ngIf="hasSapCertifications" class="classification-section__item">
      <div class="ds-color--grey-2">
        {{prepareCertificationName()}}
      </div>
      <div class="d-flex">
        <button (click)="openDsModal(partnerCertificationModalConfig)"
                [attr.data-cy]="'partner-certification-btn'"
                class="btn btn-link p-0"
        >
          <cx-media
            *ngIf="sapCertifications[0].image?.url"
            [container]="sapCertifications[0].image"
            alt="icon_sap_classification"
            class="classification-icon me-1 d-inline"
          ></cx-media>
          <span class="certification-inline">{{sapCertifications[0].value}}</span>
        </button>

        <ds-modal
          (canBeClosed)="closeDsModal(partnerCertificationModalConfig)"
          [modalHeader]="prepareCertificationName()"
          [modalIsActive]="partnerCertificationModalConfig.isActive">

          <div *ngIf="sapCertifications.length" class="modal-body sapCertificationsContainer p-0">
            <div class="row justify-content-center align-items-center">
              <div class="col-12 mb-4 mt-0 text-center">
                <cx-media
                  *ngIf="sapCertifications[0].image?.url"
                  [container]="sapCertifications[0].image"
                  alt=" "
                  class="certification-modal-classification-icon"
                ></cx-media>
              </div>
              <div class="col-12 mb-3 text-center ds-heading--s">
                {{this.sapCertifications[0].value}}
              </div>
              <div class="col-12 me-5 ms-5 mb-6 text-center ds-color--black">
                {{this.sapCertifications[0].description}}
              </div>
            </div>
          </div>

        </ds-modal>


      </div>
    </div>
    <div *ngIf="hasSolutionTypes" class="classification-section__item">
      <div class="ds-color--grey-2">
        {{prepareSolutionTypesName(false)}}
      </div>
      <div *ngIf="solutionTypes.length < 2" class="d-flex">
        <span class="ds-body ds-color–black">{{solutionTypes[0]}}</span>
      </div>
      <div *ngIf="solutionTypes.length > 1" class="d-flex">

        <button
          (click)="openDsModal(solutionTypesModalConfig)"
          class="btn btn-link p-0">

          <span>{{solutionTypes.length}} {{prepareSolutionTypesName(true)}}</span>
        </button>

        <ds-modal
          (canBeClosed)="closeDsModal(solutionTypesModalConfig)"
          [modalHeader]="prepareSolutionTypesName(false)"
          [modalIsActive]="solutionTypesModalConfig.isActive"
        >

          <table [attr.data-cy]="'solution-types-modal'">
            <tr *ngFor="let item of solutionTypes">
              <td align="left">{{item}}</td>
            </tr>
          </table>

        </ds-modal>


      </div>
    </div>
    <div *ngIf="hasWorksWith" class="classification-section__item">
      <div class="ds-color--grey-2">
        {{prepareWorksWithName(false)}}
      </div>
      <div *ngIf="worksWith.length < 2" class="d-flex">
        <span class="ds-body ds-color–black">{{worksWith[0]}}</span>
      </div>
      <div *ngIf="worksWith.length == 2" class="d-flex">
        <span class="ds-body ds-color–black">{{worksWith[0]}}, {{worksWith[1]}}</span>
      </div>
      <div *ngIf="worksWith.length > 2" class="d-flex">

        <button
          (click)="openDsModal(worksWithModalConfig)"
          class="btn btn-link p-0">

          <span>{{worksWith.length}} {{prepareWorksWithName(true)}}</span>
        </button>

        <ds-modal
          (canBeClosed)="closeDsModal(worksWithModalConfig)"
          [attr.data-cy]="'works-with'"
          [modalHeader]="prepareWorksWithName(false)"
          [modalIsActive]="worksWithModalConfig.isActive"
        >

          <table *ngIf="worksWithModalConfig.isActive" [attr.data-cy]="'works-with-modal'">
            <tr *ngFor="let item of worksWith">
              <td align="left">{{item}}</td>
            </tr>
          </table>

        </ds-modal>

      </div>
    </div>
  </div>
</ng-template>


<!--  classifications technical information section -->
<ng-template #classificationsAndCategoriesTechnicalInformationSection>
  <div *ngIf="hasGeneralTechnicalInformationSection" class="row mx-0">
    <div *ngIf="hasSolutionTypes || hasWorksWith" class="col-12 col-sm-6 ps-0">
      <div *ngIf="hasSolutionTypes" class="mb-6">
        <div class="mb-3 special-padding-left ds-heading--xs">
          {{prepareSolutionTypesName(false)}}
        </div>
        <ng-container>
          <ul class="categories-list special-padding-left technical-information">
            <li *ngFor="let item of solutionTypes">
              <div class="ds-body">
                {{item}}
              </div>
            </li>
          </ul>
        </ng-container>
      </div>
      <div *ngIf="hasWorksWith" class="mb-6">
        <div class="mb-3 special-padding-left ds-heading--xs">
          {{prepareWorksWithName(false)}}
        </div>
        <ng-container>
          <ul class="categories-list technical-information special-padding-left">
            <li *ngFor="let item of worksWith">
              <div class="ds-body">
                {{item}}
              </div>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>
    <div *ngIf="hasSapCertified || hasCategories" class="col-12 col-sm-6 ps-0">
      <div *ngIf="hasSapCertified" class="mb-6">
        <div class="mb-3 special-padding-left ds-heading--xs">
          {{prepareCertificationName()}}
        </div>
        <div class="d-flex special-padding-left">
          <button
            (click)="openDsModal(partnerCertificationTechnicalInfoConfig)"
            class="btn btn-link p-0"
          >
            <cx-media
              *ngIf="sapCertified.image?.url"
              [container]="sapCertified.image"
              alt="icon_sap_classification"
              class="classification-icon me-1 d-inline"
            ></cx-media>
            <span>{{sapCertified.value}}</span>
          </button>
          <ds-modal
            (canBeClosed)="closeDsModal(partnerCertificationTechnicalInfoConfig)"
            [modalHeader]="sapCertified.value"
            [modalIsActive]="partnerCertificationTechnicalInfoConfig.isActive">

            <div *ngIf="sapCertified" class="modal-body sapCertificationsContainer p-0">
              <div class="row justify-content-center align-items-center">
                <div class="col-12 mb-4 mt-0 text-center">
                  <cx-media
                    *ngIf="sapCertified.image?.url"
                    [container]="sapCertified.image"
                    alt="icon_sap_classification"
                    class="certification-modal-classification-icon"
                  ></cx-media>
                </div>
                <div class="me-5 ms-5 mb-6 text-center ds-color--black">
                  {{this.sapCertified.description}}
                </div>
              </div>
            </div>

          </ds-modal>
        </div>
      </div>
      <div *ngIf="hasCategories">
        <div class="mb-3 special-padding-left ds-heading--xs">
          {{'productDetails.category' | cxTranslate}}
        </div>
        <ul class="categories-list special-padding-left technical-information">
          <li *ngFor="let category of currentFilteredCategories" class="ds-body">
            <ng-container *ngFor="let supcategory of category.supcategories; let i = index">
              <span *ngIf="i > 0" class="ds-color--grey-3">{{" / "}}</span>
              <a
                (click)="displayCategory($event, supcategory.id)"
                (keydown)="displayCategoryByKeyboard($event, supcategory.id)"
                class="d-inline focusable focusable__element btn btn-link m-0 p-0 ds-color--blue"
                href="#"
              >{{supcategory.name}}</a>
            </ng-container>
            <span *ngIf="category.supcategories?.length"
                  class="d-inline ds-color--grey-3">{{" / "}}</span>
            <a
              (click)="displayCategory($event, category.id)"
              (keydown)="displayCategoryByKeyboard($event, category.id)"
              class="d-inline focusable focusable__element btn btn-link m-0 p-0 ds-color--blue"
              href="#"
            >{{category.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>

